module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/events-2015-10-07.paginators.json
// module id = 312
// module chunks = 0